import React from 'react';
import { trackCheckoutStart } from '../lib/metaPixel';
import { PRICE } from '../data/content';
import { SecurePaymentNote } from './SecurePaymentNote';

/** The single checkout the offer button leads to. */
export const CHECKOUT_URL = 'https://cosmetologyready.impultienda.ar/checkout';
export const CURRENCY_NOTE = 'Secure payment · Processed in your local currency';

/** Anchor of the offer block — the only button that opens the checkout. */
export const OFFER_ANCHOR = '#offer-cta';
interface CtaButtonProps {
  label: string;
  /** 'checkout' opens the checkout; 'offer' scrolls to the offer block. */
  action?: 'checkout' | 'offer';
  className?: string;
}
export function CtaButton({
  label,
  action = 'offer',
  className = ''
}: CtaButtonProps) {
  const isCheckout = action === 'checkout';
  return <a href={isCheckout ? CHECKOUT_URL : OFFER_ANCHOR} onClick={isCheckout ? trackCheckoutStart : undefined} className={`group inline-flex items-center justify-center gap-2.5 rounded-[14px] bg-brand-cta px-8 py-[18px] font-body text-[14px] font-bold uppercase tracking-[0.06em] text-brand-cta-text shadow-[0_5px_0_0_#3A5538,0_18px_34px_-14px_rgba(72,103,70,0.7)] transition-[background-color,transform,box-shadow] duration-150 ease-out hover:bg-brand-cta-dark active:translate-y-[3px] active:shadow-[0_2px_0_0_#3A5538] focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-cta focus-visible:ring-offset-2 focus-visible:ring-offset-brand-ivory sm:text-[15px] ${className}`} data-id="element-1" data-mp="19aa1xho41ys1">
      <span data-id="element-2" data-mp="3swk7rp7v2q3q">{label}</span>
      <span aria-hidden="true" className="text-base font-normal transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-3" data-mp="3svsn39fsycs8">
        →
      </span>
    </a>;
}
interface CtaBlockProps {
  label: string;
  /** The offer block: shows the price and is the only one that opens the checkout. */
  showPrice?: boolean;
  tone?: 'light' | 'dark';
  className?: string;
}
export function CtaBlock({
  label,
  showPrice = false,
  tone = 'light',
  className = ''
}: CtaBlockProps) {
  const muted = tone === 'dark' ? 'text-brand-ivory/60' : 'text-brand-charcoal/50';
  return <div id={showPrice ? 'offer-cta' : undefined} className={`flex scroll-mt-24 flex-col items-center text-center ${className}`} data-id="element-4" data-mp="3hzxidicaqkn1">
      {showPrice ? <>
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-gold" data-id="element-5" data-mp="3rvs3ck3zsrsz">
            Get Complete Access Today
          </p>
          <p className="mt-2 font-body text-[3rem] font-bold leading-none tracking-[-0.01em] text-brand-charcoal" data-id="element-6" data-mp="4jhl85r9xg2k">
            {PRICE}
          </p>
        </> : <p className={`font-body text-[11px] uppercase tracking-[0.14em] ${muted}`} data-id="element-7" data-mp="jenvj4xek11p">{CURRENCY_NOTE}</p>}
      <CtaButton label={label} action={showPrice ? 'checkout' : 'offer'} className="mt-4 w-full sm:w-auto sm:min-w-[420px]" data-id="element-8" data-mp="eft2791t6u3c" />
      {showPrice && <SecurePaymentNote className="mt-5" data-id="element-9" data-mp="2gala42k6ekkg" />}
    </div>;
}